import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class StateButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene, sprite1, sprite2) {
    super(scene);

    this.buttonSprite1 = ABCyaPhaser.Images.addImage(0,0,sprite1, this);
    this.buttonSprite2 = ABCyaPhaser.Images.addImage(0,0,sprite2, this);
    this.buttonSprite2.alpha = 0;
    ABCyaPhaser.Container.setContainerInteractive(this, false);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);

    this.enabled = true;
    this.doAction1 = () => {};
    this.doAction2 = () => {};
  }

  doClick () {
    if (!this.enabled) { return; }

    if (this.buttonSprite2.alpha === 1) {
      this.buttonSprite2.alpha = 0;
      this.buttonSprite1.alpha = 1;
      this.doAction1();
    }
    else {
      this.buttonSprite2.alpha = 1;
      this.buttonSprite1.alpha = 0;
      this.doAction2();
    }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
  }

  switchStateOff () {
    this.buttonSprite1.alpha = 0;
    this.buttonSprite2.alpha = 1;
  }
}